import { render, staticRenderFns } from "./tableBtn.vue?vue&type=template&id=1f503c37&scoped=true"
import script from "./tableBtn.vue?vue&type=script&lang=js"
export * from "./tableBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f503c37",
  null
  
)

export default component.exports